import _ from 'underscore'
import $ from 'jquery'
import DropdownTemplateView from '../../DropdownTemplateView'
import SimpleTooltip from '../../SimpleTooltip'

function EditActionMenu({
    buttonEl,
    onDeleteCb = () => {},
    onMoveCb = () => {},
    onCopyCb = () => {},
    copyButtonMessageKey,
})
{
    DropdownTemplateView.call(this);
    this.needCopy = false;
    this.needMove = false;
    this.needDelete = false;
    this.deleteDisable = false;
    this.$button = buttonEl;

    this.copyButtonMessageKey = copyButtonMessageKey

    this.callbacks = {
        onDeleteCb,
        onMoveCb,
        onCopyCb,
    }
}

EditActionMenu.prototype = _.create(DropdownTemplateView.prototype, {
    html: "<div class='dropdownContainer actionsMenu'>" +
          "  <div class='buttonsWrapper'>" +
          "    <div class='copyButton'>" +
          "      <div class='title'><%=copyTitle%></div>" +
          "    </div>" +
          "    <div class='moveButton'>" +
          "      <div class='title'><%=moveTitle%></div>" +
          "    </div>" +
          "    <div class='deleteButton'>" +
          "      <div class='title'><%=deleteTitle%></div>" +
          "    </div>" +
          "  </div>" +
          "</div>",

    afterRender: function()
    {
        var self = this;
        this.$wrapper = this.find(".buttonsWrapper");
        this.$copy = this.find(".copyButton");
        this.$move = this.find(".moveButton");
        this.$delete = this.find(".deleteButton");
        this.$copy.hide();
        this.$move.hide();
        this.$delete.hide();

        this.findAndBindClick(".moveButton", function() {
            if (!self.moveDisable) {
                self.triggerAction("move")
                self.callbacks.onMoveCb()
            }
        })
        this.findAndBindClick(".copyButton", function() {
            self.triggerAction("copy")
            self.callbacks.onCopyCb()
        })
        this.findAndBindClick(".deleteButton", function()
                                                {
                                                    if (!self.deleteDisable) {
                                                        self.triggerAction("delete");
                                                        self.callbacks.onDeleteCb();
                                                    }
                                                });

        this.disableDeleteTooltip().subscribeToMouseEvents(this.$delete)
        this.disableDeleteTooltip().disable()

        this.disableMoveTooltip().subscribeToMouseEvents(this.$move)
        this.disableMoveTooltip().disable()
    },

    update: function()
    {
        var widthWrapper = 0;
        if (this.needCopy)
        {
            widthWrapper += 113;
            this.$copy.show();
        }
        if (this.needMove)
        {
            widthWrapper += 112;
            this.$move.show();
        }
        if (this.needDelete)
        {
            widthWrapper += 112;
            this.$delete.show();
        }
        this.$wrapper.width(widthWrapper);
    },

    triggerAction: function(eventName)
    {
        $(this).trigger(eventName);
        this.hide();
    },

    selectMove: function(isSelected)
    {
        this.$copy.toggleClass("selected", false);
        this.$delete.toggleClass("selected", false);

        this.$move.toggleClass("selected", isSelected);
    },

    selectDelete: function(isSelected)
    {

        this.$move.toggleClass("selected", false);
        this.$copy.toggleClass("selected", false);

        this.$delete.toggleClass("selected", isSelected);
    },

    selectCopy: function(isSelected)
    {
        this.$move.toggleClass("selected", false);
        this.$delete.toggleClass("selected", false);

        this.$copy.toggleClass("selected", isSelected);
    },

    showAt: function($button, $header, positionParams, callback)
    {
        DropdownTemplateView.prototype.showAt.call(this, $button, positionParams, $header);
        this.update();
        this.callback = callback;
    },

    messageKeys: function()
    {
        return {
            moveTitle: "edit_panel.actions.move",
            copyTitle: this.copyButtonMessageKey,
            deleteTitle: "edit_panel.actions.delete"
        }
    },

    setMove: function(needMove)
    {
        this.needMove = needMove;
    },

    setCopy: function(needCopy)
    {
        this.needCopy = needCopy;
    },

    setDelete: function(needDelete)
    {
        this.needDelete = needDelete;
    },

    onHide: function()
    {
        DropdownTemplateView.prototype.onHide.call(this);
        this.callback(this.active);
    },

    setDisableDeleteButton: function(text)
    {
        this.deleteDisable = true;

        this.disableDeleteTooltip().$el.text(text)
        this.disableDeleteTooltip().enable()

        this.$delete.addClass("disable");
    },

    setEnableDeleteButton: function()
    {
        this.deleteDisable = false;

        this.disableDeleteTooltip().disable()

        this.$delete.removeClass("disable");
    },

    setDisableMoveButton: function(text) {
        this.moveDisable = true

        this.disableMoveTooltip().$el.text(text)
        this.disableMoveTooltip().enable()

        this.$move.addClass("disable")
    },

    setEnableMoveButton: function() {
        this.moveDisable = false

        this.disableMoveTooltip().disable()

        this.$move.removeClass("disable")
    },

    disableDeleteTooltip() {
        if (!EditActionMenu.deleteTooltip) {
            EditActionMenu.deleteTooltip = new SimpleTooltip({
                extraClass: 'disableDeleteTooltip',
            }).init($('body'))
        }
        return EditActionMenu.deleteTooltip
    },

    disableMoveTooltip() {
        if (!EditActionMenu.moveTooltip) {
            EditActionMenu.moveTooltip = new SimpleTooltip({
                extraClass: 'disableMoveTooltip',
            }).init($('body'))
        }
        return EditActionMenu.moveTooltip
    },

});

export default EditActionMenu



// WEBPACK FOOTER //
// ./web/js/controls/task/EditActionMenu.js